import script from "./standardOutWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./standardOutWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./standardOutWarehouse.vue?vue&type=style&index=0&id=6522f0e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6522f0e3"]])

export default __exports__